'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Dropdown = require('react-bootstrap/lib/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _common = require('../common');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatDate = _utils.FormattingUtils.formatDate;
var FollowUpDate = (_dec = (0, _mobxReact.inject)('UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(FollowUpDate, _Component);

  function FollowUpDate() {
    _classCallCheck(this, FollowUpDate);

    return _possibleConstructorReturn(this, (FollowUpDate.__proto__ || Object.getPrototypeOf(FollowUpDate)).apply(this, arguments));
  }

  _createClass(FollowUpDate, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          followUpDate = _props.followUpDate,
          label = _props.label,
          onDeleteDate = _props.onDeleteDate,
          onEditDate = _props.onEditDate,
          classNames = (0, _classnames2.default)('date-followup', 'dropdown-arrow', { 'has-value': followUpDate }),
          button = _react2.default.createElement(
        _Button2.default,
        { bsStyle: 'link', className: 'btn-edit', onClick: onEditDate },
        _react2.default.createElement(_common.Icon, { type: 'pencil' })
      ),
          dropdown = _react2.default.createElement(
        _Dropdown2.default,
        { bsStyle: 'link', id: 'followup-date-' + name, title: '' },
        _react2.default.createElement(
          _Dropdown2.default.Toggle,
          { noCaret: true, className: 'btn-link' },
          _react2.default.createElement(_common.Icon, { type: 'pencil' })
        ),
        _react2.default.createElement(
          _Dropdown2.default.Menu,
          null,
          _react2.default.createElement(
            _MenuItem2.default,
            { onClick: onEditDate },
            'Edit'
          ),
          _react2.default.createElement(
            _MenuItem2.default,
            { onClick: onDeleteDate },
            'Delete'
          )
        )
      );

      return _react2.default.createElement(
        'div',
        { className: classNames },
        label && _react2.default.createElement(
          'h4',
          null,
          label
        ),
        _react2.default.createElement(
          'span',
          { className: 'date-value' },
          formatDate(followUpDate)
        ),
        followUpDate ? dropdown : button
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FollowUpDate;
}(_react.Component), _class2.propTypes = {
  followUpDate: _propTypes2.default.string,
  label: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  onDeleteDate: _propTypes2.default.func.isRequired,
  onEditDate: _propTypes2.default.func.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = FollowUpDate;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatDate, 'formatDate', '/app/src/components/page-case/FollowUpDate.js');
  reactHotLoader.register(FollowUpDate, 'FollowUpDate', '/app/src/components/page-case/FollowUpDate.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/FollowUpDate.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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